import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../App';

const Results = () => {
  const auth = useContext(AuthContext);

  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const getResults = async () => {
      try {
        const res = await axios.get('https://iq-test-theta.vercel.app/api/test/result');
        setResult(res.data);
        setLoading(false);
      } catch (err) {
        setError('Error loading results. Please try again.');
        setLoading(false);
      }
    };

    getResults();
  }, []);

  const handleLogout = () => {
    auth.logout();
  };

  if (loading) {
    return <div className="container">Loading results...</div>;
  }

  if (error || !result) {
    return (
      <div className="container">
        <div className="alert alert-danger">{error || 'No results found. Please take the test first.'}</div>
        <button className="btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    );
  }

  return (
    <div className="container">

      <div className="result-container">
        <h1>Your IQ Test Results</h1>

        <div className="score-display">
        You answered <strong>{result.totalCorrect || 0}</strong> out of 30 questions correctly.
        </div>
        
        <div className="score-table-container">
          <table className="score-table">
            <thead>
              <tr>
                <th>Raw Score</th>
                <th>Non-verbal (Gf) IQ</th>
                <th>Percent Higher Than Population</th>
              </tr>
            </thead>
            <tbody>
              <tr className="your-score-row">
                <td>{result.totalCorrect || 0}/30</td>
                <td>{result.iqScore || 'N/A'}</td>
                <td>{result.percentile ? result.percentile.toFixed(2) : '0.00'}%</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="iq-score">
          IQ Score: {result.iqScore || 'N/A'}
        </div>

        <div className="percentile-display">
          Your score is higher than <strong>{result.percentile ? result.percentile.toFixed(2) : '0.00'}%</strong> of the population.
        </div>
        
        <div className="progress-container">
          <div className="progress-labels">
            <span>70</span>
            <span>85</span>
            <span>100</span>
            <span>115</span>
            <span>130</span>
            <span>145</span>
          </div>
          <div className="progress-bar">
            <div 
              className="progress-indicator" 
              style={{ left: `${Math.min(Math.max((((result.iqScore || 100) - 70) / 75) * 100, 0), 100)}%` }}
            ></div>
          </div>
          <div className="progress-categories">
            <span>Very Low</span>
            <span>Low</span>
            <span>Average</span>
            <span>High</span>
            <span>Very High</span>
          </div>
        </div>

        <div className="score-chart">
          <h3>IQ Score Chart</h3>
          <div className="iq-chart" style={{ textAlign: 'center', marginTop: '20px' }}>
            <img
              src={require('../assets/resultchart.png')}
              alt="IQ Score Chart"
              style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)' }}
            />
          </div>
          <p style={{ marginTop: '10px', fontStyle: 'italic', textAlign: 'center' }}>
            Test completed on: {result.completedDate ? new Date(result.completedDate).toLocaleDateString() : 'Unknown date'}
          </p>
        </div>

        <button className="submit-btn" onClick={handleLogout}>
        Take Another Test
        </button>
      </div>
    </div>
  );
};

export default Results;